import { render, staticRenderFns } from "./itemStageTreeEdit.vue?vue&type=template&id=0351fd90"
import script from "./itemStageTreeEdit.vue?vue&type=script&lang=js"
export * from "./itemStageTreeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports